import { Nullable } from 'legacy/lut/classes/models/utils'
import { HtmlField } from 'legacy/lut/components/widgets/public/partner360/fields/HtmlField'
import { FC } from 'react'

import styles from './ExecutiveSummaryReadMode.module.scss'

interface IExecutiveSummaryReadModeProps {
  executiveSummary: Nullable<string>
}

export const ExecutiveSummaryReadMode: FC<IExecutiveSummaryReadModeProps> = ({
  executiveSummary,
}) => {
  return (
    <div className={styles.root}>
      <HtmlField
        htmlClassName={styles.htmlArea}
        item={{ executiveSummary }}
        value={executiveSummary ? executiveSummary : '<b>-</b>'}
        field="executiveSummary"
      />
    </div>
  )
}
